module.exports = __webpack_public_path__ + "img/dragonspine.45e9ccc2.jpg";